export default "__VITE_ASSET__CVKiTNEM__"